<mat-form-field class="no-truncate" [class]="config?.alignment ?? GridCellContentAlignment.Left">
  <div [class]="colorOptions?.allowColorPicker ? 'd-flex align-items-center mr-n2 textFieldWithColors' : 'textField' ">
    <input
      #input
      matInput
      [(ngModel)]="context.data[context.column.columnDef]"
      [autofocus]="config?.autofocus"
      [maxlength]="config?.options?.maxLength ?? infinity"
      [disabled]="!context.cell.allowEditing"
      (focusout)="onFocusOut()"
      (change)="context.cell.actions.onEdited()"
    />

    <app-color-picker-menu
      *ngIf="colorOptions?.allowColorPicker"
      [options]="colorOptions"
      [context]="context"
    ></app-color-picker-menu>
  </div>
</mat-form-field>
